import {observable} from "mobx";

class FormStore {
    @observable email = null;
    @observable phoneNumber = null;
    @observable disableSubmit=false;
    @observable emailError= null;
    @observable phoneNumberError= null;
    @observable GDPRCheckBoxChecked= false;
    @observable GDPRCheckBoxError = false;

}

const formStore = new FormStore();
export default formStore;
